<script setup>
  import { ref,computed, getCurrentInstance, onMounted } from 'vue'
  import { usePageLoadingStore } from '../../../../../stores/pageLoading';
  import { useRoute, useRouter } from 'vue-router';
  import _ from "lodash";
  import moment from "moment";
  import adminJobfairStateService from '../../../services/jobfair/adminJobfairStateService';
  import JobFairResumeDetailModal from '../../../../user/components/modal/jobFair/JobFairResumeDetailModal.vue';
  import JobFairJobNoticeDetailModal from '../../../../user/components/modal/jobFair/JobFairJobNoticeDetailModal.vue';
  import mypageJobFairService from '../../../../user/services/mypage/jobFair/mypageJobFairService';

  const route = useRoute();
  const router = useRouter();
  const loadingStore = usePageLoadingStore();
  const { $pageListBoardNo, $toast, $number, $gbNameKR, $yyyymmddHHmmss, $interests, $jobNoticeStateGb, $intvGb, $applyStateGb, $userIntvStateGb, $adminIntvStateGb, $majorGb, alert, confirm } = getCurrentInstance().appContext.config.globalProperties;

  const data_interests = ref($interests); // 관심 카테고리
  const data_adminIntvStateGb = ref($adminIntvStateGb); // 관리자면접제안상태

  const currentPage = ref(1);
  const pageSize = ref(10);
  const totalPages = ref(0);
  const totalCount = ref(0);
  const list = ref([]);

  const jobNoticeModal = ref(null);
  const jobFairResumeModal = ref(null); // 이력서 보기

  // 검색
  const searchTypeRef = ref(null);
  const interestsListRef = ref(null);
  const adminIntvPropStateGbsListRef = ref(null);

  // 검색조건 - 페이지 크기
  const pageSizeGroup = ref([
    { label:'10개씩 보기', value: '10' },
    { label:'30개씩 보기', value: '30' },
    { label:'50개씩 보기', value: '50' },
    { label:'100개씩 보기', value: '100' },
  ])

  const searchOpen = ref(true);

  const initSearchInputModel = { // 재직자/기업(1) - 보낸 면접제안(4)
    searchInterests: ['설계','장비','소재','제조공정','패키지','테스트','SW','기타'],
    searchIntvPropStateGbs: ['01', '02', '03', '04', '05', '06'],
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
    searchType: 'name', // name 이름, id 아이디, rTitle 이력서 제목, jnTitle 채용공고제목, corpName 기업명
    searchInput: '',
  };

  const searchInput = ref({...initSearchInputModel});

  // 검색조건 - 날짜검색기준 (all 모든 기간, term 기간 검색)
  const searchDurationTypeGroup = ref([
    { label:'모든 기간', value: 'all' },
    { label:'기간 검색', value: 'term' },
  ])

  const searchTypeGroup = ref([
    { label:"이름", value: "name", placeholder: "이름을 입력해주세요."  },
    { label:"아이디", value: "id", placeholder: "아이디를 입력해주세요." },
    { label:"이력서 제목", value: "rTitle", placeholder: "이력서 제목을 입력해주세요." },
    { label:"채용공고 제목", value: "jnTitle", placeholder: "채용공고 제목을 입력해주세요."  },
    { label:"기업명", value: "corpName", placeholder: "기업명을 입력해주세요."  },
  ]);
  const searchInputPlaceholder = computed(()=>{
    const option = _.find(searchTypeGroup.value, { value: searchInput.value.searchType });
    if(option) {
      return option.placeholder;
    } else {
      return '';
    }
  })

  // 페이지 선택
  const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
  };

  // 페이지 사이즈 변경. 10,30,50,100
  const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
  }

  // 검색 - searchType 셀렉트 박스 선택시
  const onSelectsearchInput = (option) => {
    searchInput.value.searchType = option.value;
  }

  // 검색 - '초기화' 버튼 클릭
  const clearSearchInput = () => {
    searchInput.value = {...initSearchInputModel};
    interestsListRef.value?.initOptions();
    adminIntvPropStateGbsListRef.value?.initOptions();
    searchTypeRef.value?.initSelectedOption(searchInput.value.searchType);
    // retrieveList();
  }

  // 검색 - '검색' 버튼 click
  const onClickSearch = () => {
    currentPage.value = 1;
    retrieveList();
  }

  const retrieveList = () => {
    const now = new Date();
    const startYmd = searchInput.value.startYmd ? searchInput.value.startYmd : moment(now).format('YYYYMMDD');
    const endYmd = searchInput.value.endYmd ? searchInput.value.endYmd : moment(new Date(now.setDate(now.getDate() + 30))).format('YYYYMMDD');

    const paramObj = {
      searchInterests: _.map(searchInput.value.searchInterests).join(','),
      searchIntvPropStateGbs: _.map(searchInput.value.searchIntvPropStateGbs).join(','),
      startYmd: searchInput.value.searchDurationType === 'all' ? '' : startYmd,
      endYmd: searchInput.value.searchDurationType === 'all' ? '' : endYmd,
      searchType: searchInput.value.searchType,
      searchInput: searchInput.value.searchInput,
      pageNumber: currentPage.value,
      size: pageSize.value,
    };

    loadingStore.loading = false;
    adminJobfairStateService.retrieveAllInterviewProposalEntryListPaging(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if (res.data.code.toLowerCase() === "success") {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      })
      .catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
      });
  }

  // 이력서 보기
  const onClickMyResume = async (resumeId, delYn) => {
    if (delYn === 'Y') {
      alert(["삭제된 이력서 입니다."]);
    } else {
      await jobFairResumeModal.value.show({
        resumeId,
        showDeleteBtn: false,
      });
    }
  }

  // 채용공고 보기
  const onClickJobNotice = async (jobNoticeSeq, corpId) => {
    await jobNoticeModal.value.show({
      jobNoticeSeq,
      corpId,
    });
  }

  // 보낸 면접제안 상태변경
  const onClickIntvPropState = async (resumeId, jobNoticeSeq, stateGb) => {
    let ok, messageContent, okButtonText;
    if(stateGb === '04') {
      messageContent = ["제안을 취소 하시겠습니까?", "'제안취소'로 상태가 변경됩니다."];
      okButtonText = "제안취소";
    } else if(stateGb === '05') {
      messageContent = ["최종합격 처리하시겠습니까?", "'최종합격'으로 상태가 변경됩니다."];
      okButtonText = "최종합격";
    } else if(stateGb === '06') {
      messageContent = ["최종불합격 처리하시겠습니까?", "'최종불합격'으로 상태가 변경됩니다."];
      okButtonText = "최종불합격";
    }

    ok = await confirm(messageContent, okButtonText);
    if(ok) {
      const paramObj = {
        resumeId,
        jobNoticeSeq,
        intvPropStateGb: stateGb,
      };

      mypageJobFairService.updateIntvPropStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            alert(["변경하였습니다."]);
            retrieveList();
          } else {
            alert(["변경을 실패하였습니다."]);
          }
        })
        .catch( (res) =>  {
          loadingStore.loading = false;
          alert(["변경을 실패하였습니다."]);
        });
    }
  }

  const openDetailInNewTab = (linkName, id, query = {}) => {
    const url = router.resolve({
      name: linkName,
      params: { id },
      query,
    }).href;

    window.open(url, '_blank');
  }

  onMounted(() => {
    retrieveList();
  })
</script>
<template>
  <div>
    <!-- s: 검색 -->
    <div class="filter-wrap" :class="{'open': searchOpen}">
      <p @click="searchOpen = !searchOpen">검색</p>
      <div class="filter">
        <dl>
          <dt style="display:block;"><span>관심 카테고리</span><br/><small style="font-weight: normal;">복수 선택 가능</small></dt>
          <dd>
            <KSACheckBoxGroup
              ref="interestsListRef"
              className="mr-md"
              name="interestsList"
              v-model="searchInput.searchInterests"
              :options="data_interests"
            />
          </dd>
        </dl>
        <dl>
          <dt style="display:block;">상태</dt>
          <dd>
            <KSACheckBoxGroup
              ref="adminIntvPropStateGbsListRef"
              className="mr-md"
              name="adminIntvPropStateGbsList"
              v-model="searchInput.searchIntvPropStateGbs"
              :options="data_adminIntvStateGb"
            />
          </dd>
        </dl>
        <dl>
          <dt>제안 보낸일</dt>
          <dd class="text-box">
            <div class="grid">
              <template v-for="group in searchDurationTypeGroup" key="item.value" >
                <KSARadioButton class="mr-md" :label="group.label" v-model="searchInput.searchDurationType" :value="group.value" />
              </template>
              <div style="display: inline-block;" v-if="searchInput.searchDurationType !== 'all'">
                <KSADatepickerTerms
                  :startDate="searchInput.startYmd"
                  :endDate="searchInput.endYmd"
                  @update:startDate="(value)=> searchInput.startYmd = value"
                  @update:endDate="(value)=> searchInput.endYmd = value"
                />
              </div>
            </div>
          </dd>
        </dl>
        <!-- name 이름, id 아이디, rTitle 이력서 제목, jnTitle 채용공고제목, corpName 기업명 검색 -->
        <dl>
          <dt>
            <KSASelect ref="searchTypeRef" :options="searchTypeGroup" class="select" @selectOption="onSelectsearchInput"/>
          </dt>
          <dd>
            <KSAInput class="text-box" v-model="searchInput.searchInput" :placeholder="searchInputPlaceholder" />
          </dd>
        </dl>
        <div class="btn-wrap">
          <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
          <KSAPrimaryButton text="검색" @click="onClickSearch" />
        </div>
      </div>
    </div>
    <!-- e: 검색 -->
    <div class="list-top">
      <p>총 <span>{{ $number(totalCount)}}</span>개</p>
      <div>
        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
      </div>
    </div>
    <div class="table-form">
      <table class="horizontal">
        <tr>
          <th>NO</th>
          <th>회원코드</th>
          <th>이름</th>
          <th>아이디</th>
          <th>이력서 제목</th>
          <th>관심 카테고리</th>
          <th>전공계열(주전공)</th>
          <th>면접제안 공고 제목</th>
          <th>기업명</th>
          <th>마스터</th>
          <th>제안일</th>
          <th>상태</th>
          <th>상태 변경</th>
        </tr>
        <tr v-for="intvProposal in list">
          <td>{{ intvProposal.boardNo }}</td>
          <td>{{ intvProposal.userCd }}</td>
          <td class="clickable blue">
            <span @click="openDetailInNewTab('MemberDetail', intvProposal.userCd)">{{ intvProposal.userName }}</span>
          </td>
          <td>{{ intvProposal.userLoginId }}</td>
          <td class="text-overflow long-overflow">
            <span class="file" v-if="intvProposal.fileYn === 'Y'" v-for="resumeAttaches in intvProposal.resumeAttaches" @click="$downloadForPrivate({fileName:resumeAttaches.fileName, fileDir: resumeAttaches.fileDir })">
              {{ resumeAttaches.fileName }}
            </span>
            <span class="clickable blue" v-else @click="onClickMyResume(intvProposal.resumeId, intvProposal.delYn)">
              {{ intvProposal.title }}
            </span>
          </td>
          <td>{{ intvProposal.interests }}</td>
          <td>{{ $gbNameKR('MAJOR_GB', intvProposal.majorGb) }}</td>
          <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(intvProposal.jobNoticeSeq, intvProposal.corpId)">{{ intvProposal.jobName }}</td>
          <td class="clickable blue text-overflow long-overflow">
            <span @click="openDetailInNewTab('CorporationDetail', intvProposal.corpId, { tab: 3, tab2: 'job-postings' })">{{ intvProposal.corpName }}</span>
          </td>
          <td class="clickable blue">
            <span @click="openDetailInNewTab('MemberDetail', intvProposal.masterUserId)">{{ intvProposal.masterUserName }}</span>
          </td>
          <td>{{ $yyyymmddHHmmss(intvProposal.createDate) }}</td>
          <td>
            <span v-if="intvProposal.intvPropStateGb === '01'">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',intvProposal.intvPropStateGb) }}</span>
            <span v-else-if="intvProposal.intvPropStateGb === '02' || intvProposal.intvPropStateGb === '05'" class="blue">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',intvProposal.intvPropStateGb) }}</span>
            <span v-else-if="intvProposal.intvPropStateGb === '03' || intvProposal.intvPropStateGb === '06'" class="red">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',intvProposal.intvPropStateGb) }}</span>
            <span v-else class="gray">{{ $gbNameKR('ADMIN_INTV_PROP_STATE_GB',intvProposal.intvPropStateGb) }}</span>
          </td>
          <td>
            <span v-if="intvProposal.intvPropStateGb === '01'">
              <!-- 제안보냄 -->
              <KSATextButton class="clickable black" text="제안취소" @click="onClickIntvPropState(intvProposal.resumeId, intvProposal.jobNoticeSeq, '04')"/>
            </span>
            <span v-else-if="intvProposal.intvPropStateGb === '02'">
              <!-- 제안수락 -->
              <KSATextButton class="clickable black" text="최종합격" @click="onClickIntvPropState(intvProposal.resumeId, intvProposal.jobNoticeSeq, '05')"/>
              &nbsp;
              <KSATextButton class="clickable black" text="최종불합격" @click="onClickIntvPropState(intvProposal.resumeId, intvProposal.jobNoticeSeq, '06')"/>
            </span>
            <span v-else-if="intvProposal.intvPropStateGb === '05'">
              <!-- 최종합격 -->
              <KSATextButton class="clickable black" text="최종불합격" @click="onClickIntvPropState(intvProposal.resumeId, intvProposal.jobNoticeSeq, '06')"/>
            </span>
            <span v-else-if="intvProposal.intvPropStateGb === '06'">
              <!-- 최종불합격 -->
              <KSATextButton class="clickable black" text="최종합격" @click="onClickIntvPropState(intvProposal.resumeId, intvProposal.jobNoticeSeq, '05')"/>
            </span>
            <span v-else>
              -
            </span>
          </td>
        </tr>
      </table>
      <div class="result-none" v-if="list.length === 0">
        보낸 면접제안 내역이 없습니다.
      </div>
    </div>
    <Paginate
      v-if="list.length > 0"
      v-model="currentPage"
      :page-count="totalPages"
      :click-handler="onSelectPage"
    />
  </div>
  <JobFairJobNoticeDetailModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
  <JobFairResumeDetailModal ref="jobFairResumeModal" /> <!-- 이력서 보기 -->
</template>

<style scoped>
.text-overflow.long-overflow {
  max-width: 210px;
}
</style>
